import React from "react";
import { IconButton } from "../icon-button";
import { Tooltip } from "../tooltip";

import "./navigation-bar.css";

export const NavigationBar = ({
	totalNbrOfSpreads,
	currentSpreadNbr,
	navigationBarText,
	onChangeSpreadNbr,
	toolTipRightText,
	onToolTipRightClick,
}: {
	totalNbrOfSpreads: number;

	/** 1-based spread number */
	currentSpreadNbr: number;

	navigationBarText: string;

	/** User requests a new spread
	 * @param newSpreadNbr 1-based spread number to show
	 */
	onChangeSpreadNbr(newSpreadNbr: number): void;

	toolTipRightText: string;

	onToolTipRightClick: () => void;
	// Remark:
	// We now only support single page spreads,
	// If we want to support multiple page spreads, we also will need:
	// - totalNbrOfPages
	// - currentPageNbr:
	// - pagesPerSpread
}) => {
	const isPrevDisabled = currentSpreadNbr <= 1;
	const isNextDisabled = currentSpreadNbr >= totalNbrOfSpreads;
	const navigationBarLabel = navigationBarText || "";

	return (
		<div className="navigation-bar">
			<span className="navigation-bar--background">
				<IconButton
					className="navigation-bar__previous"
					disabled={isPrevDisabled}
					onClick={() => {
						onChangeSpreadNbr(currentSpreadNbr - 1);
					}}
					iconName="angle-left"
				/>
				<span className="navigation-bar__text">{navigationBarLabel}</span>
				<Tooltip
					direction="up"
					message={toolTipRightText}
					show={!!toolTipRightText}
					onClick={onToolTipRightClick}
				>
					<IconButton
						className="navigation-bar__next"
						disabled={isNextDisabled}
						onClick={() => {
							onChangeSpreadNbr(currentSpreadNbr + 1);
						}}
						iconName="angle-right"
					/>
				</Tooltip>
			</span>
		</div>
	);
};
NavigationBar.displayName = "NavigationBar";
